export const BASE_CLASSES =
  "border-2 border-gray-300 bg-white text-black transition-all rounded-lg outline-none px-2 py-2 placeholder:text-gray-300"

export const BASE_FOCUS_CLASSES = "focus:border-primary-base"
export const BASE_DISABLED_CLASSES = "bg-gray-100 text-gray-400"
export const BASE_ERROR_CLASSES = "border-error-base"
